module.exports = __webpack_public_path__ + "static/media/flag-orange.12d68224.svg";